<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            @click="currentDeductionTypeSlug = $event.slug"
        >
            <template v-slot:table-actions>
                <button type="button" class="btn btn-primary btn-collapse-md" @click.prevent="currentDeductionTypeSlug = null; addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i>
                    <span class="btn-text">Add Deduction Type</span>
                </button>
            </template>
        </fast-table>

        <sidebar
            :deduction-type="currentDeductionType"
            v-if="currentDeductionTypeSlug"
            @updated="onUpdate($event)"
            @deleted="currentDeductionTypeSlug = null; getData()"
            @close="currentDeductionTypeSlug = null"
        />
        <add-modal v-if="addModalOpen" @updated="getData()" @close="addModalOpen = false" />

    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import AddModal from './components/DeductionTypeModal'
import Sidebar from './components/DeductionTypeSidebar'

export default {
    components: {FastTable, Page, Sidebar, AddModal, },
    computed: {
        currentDeductionType() {
            return this.deductionTypes.find(d => d.slug == this.currentDeductionTypeSlug)
        },
        tableData() {
            const sectionData = this.deductionTypes.map((d, idx) => ({
                id: idx,
                isActive: this.currentDeductionTypeSlug && d.slug == this.currentDeductionTypeSlug,
                object: d,
                cells: [
                    d.name,
                    d.category_pretty,
                    d.has_been_used ? 'Yes' : 'No',
                    d.symmetry_benefit_type_pretty,
                    d.for_primary_benefit_of_employer,
                ],
            }))
            return [sectionData]
        },
    },
    data() {
        return {
            deductionTypes: [],
            dataLoaded: false,
            currentDeductionTypeSlug: null,
            addModalOpen: false,

            headers: [
                {label: 'Deduction Type', classes: '', isSearchable: true, defaultSort: true},
                {label: 'Category', classes: 'cw-8', isFilterable: true},
                {label: 'Has Been Used', classes: 'cw-5', isFilterable: true},
                {label: 'Sym. Benefit Type', classes: 'cw-8', isFilterable: true},
                {label: 'Employer Benefit', classes: 'cw-5', type: 'checkmark', isFilterable: true},
            ],
            sections: [
                {title: '', defaultIsClosed: false, id: 1},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Deduction Types')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/admin/tax-engine/deduction-types`).then(resp => {
                this.deductionTypes = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
        onUpdate(deductionType) {
            if (!deductionType) {
                return this.getData()
            }
            const existing = this.deductionTypes.find(x => x.slug == deductionType.slug)
            if (existing) {
                Object.assign(existing, deductionType)
            }
            else { this.getData() }
        },
    },
}

</script>
